import React from "react";
import { createContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateInPersonStatus } from "../state/patient/patientSlice";


const WEBSOCKET_URL = process.env.GATSBY_WEBSOCKET;
export const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {

  console.log("WebSocketProviderrrrrrrrrrr", WEBSOCKET_URL);
  const dispatch = useDispatch();
  const audioFileId = useSelector((state) => state.patients.audioFileId);
  const [status, setStatus] = useState("");
  // const audioId = `${audioFileId}.webm`;
  const audioFileIdRef = useRef(audioFileId);

  useEffect(() => {
    audioFileIdRef.current = audioFileId;
  }, [audioFileId]);
  const wsRef = useRef(null);

  useEffect(() => {
    console.log("Initializing WebSocket with audioFileId:", audioFileId);
    if (!audioFileId || wsRef.current) return;
    const ws = new WebSocket(WEBSOCKET_URL);
    wsRef.current = ws;

    ws.onopen = () => {
      console.log("WebSocket connected");
      const subscriptionMessage = {
        action: "subscribe",
        audioFileId: audioFileIdRef.current,
      };
      ws.send(JSON.stringify(subscriptionMessage));
      console.log("Sent subscription message:", subscriptionMessage);
    };

    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        console.log("Message received:", data);
        setStatus(data.status);
        // dispatch(updateInPersonStatus(data.status))
      } catch (error) {
        console.error("Error parsing message:", error);
      }
    };

    ws.onclose = () => {
      wsRef.current = null
      console.log("WebSocket closed");
    };

    ws.onerror = (error) => {
      console.error("WebSocket error:", error);
    };

  }, [audioFileId, dispatch]);

  return (
    <WebSocketContext.Provider value={{ ws: wsRef.current, status, updateStatus: (s) => {setStatus(s)} }}>
      {children}
    </WebSocketContext.Provider>
  );
};




// const useWebSocket = () => {
//   const dispatch = useDispatch();
//   const audioFileId = useSelector((state) => state.patients.audioFileId);
//   const audioId = `${audioFileId}.webm`;
//   const wsRef = useRef(null); // Use a ref to manage WebSocket instance

//   useEffect(() => {
//     if (!audioFileId) return;

//     console.log("Initializing WebSocket with audioFileId:", audioFileId);

//     // Close any existing WebSocket connection before creating a new one
//     if (wsRef.current) {
//       wsRef.current.close();
//     }

//     const ws = new WebSocket(WEBSOCKET_URL);
//     wsRef.current = ws;

//     ws.onopen = () => {
//       console.log("WebSocket connected");
//       const subscriptionMessage = {
//         action: "subscribe",
//         audioFileId: audioId,
//       };
//       ws.send(JSON.stringify(subscriptionMessage));
//       console.log("Sent subscription message:", subscriptionMessage);
//     };

//     ws.onmessage = (event) => {
//       const data = JSON.parse(event.data);
//       console.log("Message received:", data);
//       dispatch(updateInPersonStatus(data.status)); // Dispatch updated status
//     };

//     ws.onclose = () => {
//       console.log("WebSocket closed");
//     };

//     ws.onerror = (error) => {
//       console.error("WebSocket error:", error);
//     };

//     // Cleanup WebSocket on component unmount or audioFileId change
//     return () => {
//       if (ws) {
//         ws.close();
//         console.log("WebSocket connection closed");
//       }
//     };
//   }, [audioFileId, dispatch]); // React to audioFileId changes
// };

// export default useWebSocket;
